import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '../core/authentication/authentication.service';

/** GET /channel/images/{channelId}: full image URLs, main image first. */
export interface ChannelImages {
    channelId: number;
    name: string;
    images: string[];
}

@Injectable({ providedIn: 'root' })
export class ChannelService {
    constructor(
        private http: HttpClient,
        private authenticationService: AuthenticationService
    ) {}

    getChannelImages(channelId: number | string): Observable<ChannelImages> {
        return this.http.get<ChannelImages>(`${environment.apiUrl}/channel/images/${channelId}`);
    }

    getChannelsSuppliersIdsByCampaignId(campaignId: string) {
        return this.http.get(
            `${
                environment.apiUrl
            }/channel/${campaignId}/${this.authenticationService.getSessionRole()}`
        );
    }

    getOnceCampaignLiveChannelsAndDateRange(campaignId: string) {
        return this.http.get(
            `${environment.apiUrl}/campaign/analytics/get-channels-with-live-history/${campaignId}`
        );
    }

    getCampaignChannelDateRange(campaignId: string, channels) {
        return this.http.post(
            `${environment.apiUrl}/campaign/analytics/get-channels-date-range/${campaignId}`,
            channels
        );
    }
}
